export const isAwsArn = (destination: string) =>
  destination.startsWith("arn:aws");
export const isGcloudResourceUrl = (destination: string) =>
  destination.startsWith("//compute.googleapis.com");
export const isAzureInstanceId = (destination: string) =>
  destination.startsWith("/subscriptions/");

export const VALID_GCLOUD_PROVIDERS = ["gcloud", "gcp"];

export const normalizeProvider = (provider: string | undefined) => {
  return provider?.toLowerCase();
};

export const isAwsId = (id: string) => id.match(/^aws:/);
export const isGcloudId = (id: string) => id.match(/^gcloud:/);
export const isAzureId = (id: string) => id.match(/^azure:/);

/**
 * Extracts the ID part from a provider:itemId format string
 * @param providerId - String in format "aws:accountId", "gcloud:projectId", or "azure:subscriptionId"
 * @returns The ID part after the colon, or the original string if no colon is found
 */
export const toParentId = (providerId: string): string => {
  const parts = providerId.split(":");
  return parts.length > 1 ? parts[1] : providerId;
};
